/** Rule-source selector: external regulation vs the company's own policy.
 *
 *  Split out of RuleFormFields to keep that file under 200 lines.
 */
import { UseFormRegister } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import type { RuleFormValues } from './RuleFormValues';

interface RuleSourceFieldProps {
  register: UseFormRegister<RuleFormValues>;
  source: 'regulatory' | 'internal_policy';
  severity: RuleFormValues['severity'];
  className: string;
}

export function RuleSourceField({ register, source, severity, className }: RuleSourceFieldProps) {
  // Info-severity policy rules are advisory — they never lock approval.
  const willLockApproval = source === 'internal_policy' && severity !== 'info';

  return (
    <div>
      <Label htmlFor="source">Rule source</Label>
      <select id="source" {...register('source')} className={className}>
        <option value="regulatory">Regulatory — external law or regulation</option>
        <option value="internal_policy">Internal policy — this company&apos;s own rule</option>
      </select>
      <p className="mt-1 text-xs text-muted-foreground">
        {willLockApproval ? (
          <>
            A contract breaching this rule can only be approved by a{' '}
            <strong>senior reviewer</strong> or admin (INV-POL-01).
          </>
        ) : source === 'internal_policy' ? (
          'Info-severity policy rules are advisory — they do not restrict who can approve.'
        ) : (
          'Regulatory rules follow the normal gate verdict and review flow.'
        )}
      </p>
    </div>
  );
}
